import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import i18next from 'i18next';
import UserContext from '../../context/UserContext';
import {useHungerEffectsEnabled, setHungerEffectsEnabled} from '../hungerEffects';
import {vtmT} from '../i18n';
import {SYSTEMS, getSystemUrl} from '../../utils/gameSystem';
import '../../styles/vtm/headerbar.css';

/** Barre de navigation VtM : retour à l'accueil et menu du joueur (déconnexion). */
const VtmHeaderBar = () => {
  const {user, updateUser} = useContext(UserContext);
  const hungerEffects = useHungerEffectsEnabled();

  const logout = () => {
    updateUser({uid: null, displayName: null});
    firebase.auth().signOut();
  };

  return (
    <div className="vtmHeaderBar" role="banner">
      <nav className="vtmHeaderInner" aria-label="Navigation">
        <Link className="vtmHomeLink" to="/campaigns">Pray the Dice</Link>
        <details className="vtmUserMenu">
          <summary>{user.name || user.displayName}</summary>
          <div className="vtmUserMenuContent">
            <button type="button" className="vtmMenuToggle" aria-pressed={hungerEffects} onClick={() => setHungerEffectsEnabled(!hungerEffects)}>
              {vtmT('hungerEffects')}
              <span className="vtmMenuToggleState">{hungerEffects ? vtmT('on') : vtmT('off')}</span>
            </button>
            <a className="vtmMenuLink" href={getSystemUrl(SYSTEMS.ARIA, window.location, '/')}>{vtmT('switchGame')}</a>
            <button type="button" onClick={logout}>{i18next.t('logout')}</button>
          </div>
        </details>
      </nav>
    </div>
  );
};

export default VtmHeaderBar;
